import { makeVar } from "@apollo/client";

export const myRosterSelectedVar = makeVar<boolean>(true);
